import { render, staticRenderFns } from "./GastosForm.vue?vue&type=template&id=79b1926a"
import script from "./GastosForm.vue?vue&type=script&lang=js"
export * from "./GastosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports